module.exports = __webpack_public_path__ + "images/modal/sns_share_modal/hikakaku-hand-mobile_1289b9dffa992ec9e3f71f34358c05e7.svg";